<div class="user-settings-container">
  <div class="user-settings-content">
    <div class="user-settings-header flex justify-between items-center">
      <div class="user-settings-title flex flex-row items-center">
        <img src="/assets/icons/users.svg" alt="Users" />
        <div class="title">Users</div>
      </div>
      <div>
        <a
          *ngIf="canCrudUsers$ | async"
          saAutomatedSelector="users__add-button"
          (click)="openUserDetailView({})"
          class="button-add"
          >Add</a
        >
      </div>
    </div>
    <div>
      <mat-table #table (matSortChange)="sortTable($event)" [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="userName">
          <mat-header-cell class="grow2" *matHeaderCellDef mat-sort-header>Name</mat-header-cell>
          <mat-cell class="grow2" *matCellDef="let row" saAutomatedSelector="user__name">{{
            row.name || 'No Name'
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="email">
          <mat-header-cell class="grow3" *matHeaderCellDef mat-sort-header>Email</mat-header-cell>
          <mat-cell class="grow3" *matCellDef="let row" saAutomatedSelector="user__email">{{
            row.email || 'No Email'
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="phone">
          <mat-header-cell *matHeaderCellDef>Role</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <span *ngIf="row.accountRoles[0].id == 1">Admin</span>
            <span *ngIf="row.accountRoles[0].id == 2">Standard</span>
            <span *ngIf="row.accountRoles[0].id == 5">Crew Leader</span>
            <span *ngIf="row.accountRoles[0].id == 4">View Only</span>
            <span *ngIf="row.accountRoles[0].id == 9">Sand Coordinator</span>
            <span *ngIf="row.accountRoles[0].id == 10">Dispatcher</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="action">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell class="grid justify-items-end" *matCellDef="let row" saAutomatedSelector="user__edit">
            <i class="material-icons cursor-pointer" (click)="openUserDetailView(row)">edit</i>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedColumns"
          saAutomatedSelector="user__row"
          [automatedName]="row.name"
        ></mat-row>
      </mat-table>
    </div>
  </div>

  <sa-detail-view [model]="detailView" (onUserUpdated)="userUpdated($event)" (onCloseClicked)="closeUserDetailView()">
  </sa-detail-view>
</div>
